export const getStringCategories = (categories = []) => {
	if (!categories.length) return "all";

	return categories.reduce((acc, val) => {
		if (acc === "") {
			acc += val;
		} else {
			acc += `,${val}`;
		}
		return acc;
	}, "");
};
